<template>
  <section class="card-recharge-bed">
    <title-bar title="公交卡挂失"
               :isDefaultColor="true"></title-bar>
    <div class="info-box">
      <div class="info-li">
        <img src="../assets/img/cardRecharge/icon_card.png" />

        <div class="select"
             style="margin-top:0px;outline:none;border:1px solid #fff;border-radius:4px;position:relative;">

          <select required
                  class="orderTimeDataSel"
                  v-model="cardType">
            <option value=""
                    disabled
                    selected
                    hidden><span>请选择卡片类型</span>

            </option>
            <option value="99">cpu普通卡</option>
            <option value="01">cpu老年卡</option>
            <option value="07">cpu爱心卡</option>
            <option value="03">cpu学生卡</option>
          </select>
        </div>
        <img src="../assets/img/cardRecharge/icon_down.png"
             class="down" />

        <!-- <input type="text"
               v-model="name"
               placeholder="请输入您的姓名" /> -->
      </div>
      <!-- <div class="info-li">
        <img src="../assets/img/cardRecharge/icon_card.png" />
        <span v-if="!cardType">卡片类型</span>
        <span v-else>{{cardType}}</span>
        <input type="tel"
               v-model="idcard"
               maxlength="8"
               placeholder="请输入卡号后8位" />
      </div> -->
      <div class="info-li">
        <img src="../assets/img/cardRecharge/icon_phone.png" />
        <span>手机号</span>
        <input type="tel"
               v-model="phone"
               maxlength="16"
               placeholder="请输入手机号" />
      </div>
      <div class="info-li">
        <img src="../assets/img/cardRecharge/icon_name.png" />
        <span>姓名</span>
        <input type="tel"
               v-model="name"
               maxlength="16"
               placeholder="请输入持卡人姓名" />
      </div>
      <div class="info-li">
        <img src="../assets/img/cardRecharge/icon_idcard.png" />
        <span>身份证号</span>
        <input type="tel"
               v-model="idcard"
               maxlength="18"
               placeholder="请输入持卡人身份证号" />
      </div>
      <div class="warning">温馨提示：<br />
        支持CPU本地普通卡、CPU本地学生卡、CPU本地老年卡、CPU本地爱心卡在线挂失补办。</div>
      <div class="btn-box"
           v-if="!cardType">
        <div>提交</div>
      </div>
      <div class="btn-ready"
           v-else
           @click="submit()">
        <div>提交</div>
      </div>
    </div>
    <sure-info :isShow="isShow_sure"
               title='提交成功'
               content="挂失24小时之内必须完成补办，否则挂失失效。">
      <div @click="readEnd">前往补办页面</div>
    </sure-info>
    <fail-info :isShow="isShow_fail"
               title='挂失失败'
               :content="msg">
      <div @click="back">确定</div>
    </fail-info>

  </section>
</template>
<script>
import { checkCard, userCardQuery, cardNewApply } from '@/api/list'
import TitleBar from '@/components/TitleBar.vue'
import TipsInfo from '@/components/TipsInfo.vue'
import SureInfo from '../components/SureInfo.vue'
import failInfo from '@/components/failInfo.vue'

// import Upload from '@/components/Upload.vue'
export default {
  name: 'cardLost',
  data () {
    return {
      isGetCard: false,
      imgUrl: '',
      name: '',
      idcard: '',
      phone: '',
      cardNo: '',
      numList: [20, 50, 100],
      payNum: 0,
      checked: true,
      cardType: '',
      isShow_sure: false,
      isShow_fail: false,
      msg: '',
      cardList: {}

    }
  },
  computed: {

  },
  components: { TitleBar, SureInfo, failInfo },
  mounted () {

  },
  methods: {
    back () {
      this.isShow_fail = false
    },
    readEnd () {
      this.isShow_sure = false
      if (this.cardType == '03') {
        this.$router.push({
          name: 'replaceStudent',
          params: {
            cardList: this.cardList,
            cardInfo: {
              name: this.name,
              cardType: this.cardType,
              IDCard: this.idcard,
              phone: this.phone
            }
          }
        })
      } else {
        this.$router.push({
          name: 'replaceNormal',
          params: {
            cardList: this.cardList,
            cardInfo: {
              name: this.name,
              cardType: this.cardType,
              IDCard: this.idcard,
              phone: this.phone
            }
          }
        })

      }


    },

    commit () {

      this.isShow = true
    },

    flag () {
      this.checked = !this.checked

    },
    choosePay (index) {
      this.payNum = index;
    },
    returnRouter () {
      this.$router.push({
        name: 'yearCheckSelect'
      })
    },
    getImgUrl (img) {
      this.isGetCard = true
      this.imgUrl = img
    },
    submit () {
      if (!this.name) {
        this.$eventBus.$emit('getTipsInfo', {
          msg: '请填写姓名'
        })
        return false
      }
      if (!/^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(this.idcard)) {
        this.$eventBus.$emit('getTipsInfo', {
          msg: '请输入合法的身份证号码'
        })
        return false
      }
      if (!/^[1][3,4,5,7,8][0-9]{9}$/.test(this.phone)) {
        this.$eventBus.$emit('getTipsInfo', {
          msg: '请输入手机号码'
        })
        return false
      }

      const params = {
        name: this.name,
        cardType: this.cardType,
        IDCard: this.idcard,
        phone: this.phone
      }
      userCardQuery(params).then(data => {
        if (data.respCode === '01') {
          if (data.data.cardList.length == 1) {
            this.cardList = JSON.stringify(data.data.cardList[0]);
            this.isShow_sure = true
            // const params_cardNewApply = {
            //   name: this.name,
            //   cardType: this.cardType,
            //   IDCard: this.idcard,
            //   phone: this.phone,
            //   oldCardNo: data.data.cardList[0].icCardNo,
            //   businessType: '02'
            // }
            // cardNewApply(params_cardNewApply).then(data => {
            //   if (data.respCode === '01') {
            //     this.isShow_sure = true

            //   } else {
            //     this.msg = data.respMsg;
            //     this.isShow_fail = true
            //   }

            // }).catch(err => {
            //   this.$eventBus.$emit('getTipsInfo', {
            //     msg: err
            //   })
            // })


          } else {
            this.msg = "存在多张同类卡片，请携带有效证件前往阳泉市XXXXXX进行挂失，或致电0353 - 2054111进行挂失。";
            this.isShow_fail = true
          }
        } else {
          this.msg = data.respMsg;
          this.isShow_fail = true
        }

      }).catch(err => {
        this.$eventBus.$emit('getTipsInfo', {
          msg: err
        })
      })

    }
  }
}
</script>
<style lang="scss" scoped>
.card-recharge-bed {
  height: 100%;
  background: #fff;
}
.info-box {
  margin-top: 16px;
  .orderTimeDataSel {
    height: 40px;
    -webkit-appearance: none;
    appearance: none;
    border: none;
    font-size: 26px;
    padding: 0px 20px;
    display: block;
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #ffffff;
    color: #333333;
    border-radius: 4px;
  }
  > .info-li {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 24px 32px;
    font-size: 26px;
    font-family: 宋体;
    color: #333333;
    border-bottom: 1px solid #e8ebf0;
    .down {
      width: 14px;
      height: 8px;
    }
    img {
      width: 48px;
      height: 48px;
    }

    span {
      display: inline-block;
      padding: 0 20px;
      width: 180px;
      white-space: nowrap;
      text-align: left;
      // text-align-last: justify;
    }
    input {
      flex: 1;
      border: 0;
      padding-left: 20px;
    }
  }
  > .warning {
    padding: 30px 32px;
    font-size: 22px;
    font-family: 宋体;
    font-weight: 400;
    color: #ef4141;
    text-align: left;
  }
}
.recharge {
  margin-top: 16px;
  width: 100%;
  background-color: #fff;
  padding-bottom: 340px;
  p {
    padding: 24px 32px;
    text-align: left;
    font-size: 30px;
    font-family: 宋体;
    font-weight: 500;
    color: #333333;
  }
  ul {
    width: calc(100% - 64px);
    height: 80px;
    line-height: 80px;
    margin-left: 32px;
    margin-bottom: 32px;
    display: flex;
    justify-content: space-between;
    li {
      width: 31%;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #e8ebf0;
      font-size: 30px;
      font-family: 宋体;
      font-weight: 400;
      color: #384253;
    }
    .checked {
      background: #2489ff;
      border: 1px solid #5fbaf3;
      color: #ffffff;
    }
  }
  .pay-type {
    padding: 0px 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon-type {
      display: flex;
      align-items: center;
    }
    img {
      width: 48px;
      height: 48px;
    }
    .choose {
      width: 40px;
      height: 40px;
    }
    span {
      margin-left: 10px;
    }
    .radio {
      width: 20px;
      height: 20px;
      border: 2px solid rgb(163, 158, 158);
      border-radius: 50%;
    }
  }
}
.btn-box {
  margin: 50px 60px;
  background: #f5f6f8;
  border-radius: 44px 44px 44px 44px;
  padding: 20px 0;
  border-radius: 70px;
  margin-top: 100px;
  font-size: 30px;
  font-family: 宋体;
  font-weight: 400;
  color: #8f98a8;
}
.btn-ready {
  margin: 50px 60px;
  background: #2489ff;
  border-radius: 44px 44px 44px 44px;
  padding: 20px 0;
  border-radius: 70px;
  margin-top: 100px;
  font-size: 30px;
  font-family: 宋体;
  font-weight: 400;
  color: #ffffff;
}
.show-img {
  width: calc(100% - 40px);
  padding: 20px;
  max-height: 100%;
  box-sizing: border-box;
}
input::-webkit-input-placeholder {
  color: #8f98a8;
}
</style>
